import { loadPinCatalog, occurrenceMarkerIcon } from '../utils/pinMarker'

/** Pin personalizado da ocorrência (tipo ou disciplina) nos mapas que desenham o ponto da ocorrência. */
export default {
  created() {
    loadPinCatalog(this.$http, this.$store.state.api)
  },

  methods: {
    /** Ícone do marcador, ou undefined para o Google Maps usar o marcador padrão. */
    occurrencePinIcon(occ, size) {
      return occurrenceMarkerIcon(occ, size) || undefined
    },
  },
}
